import Vue from 'vue';
import dialogHelpVue from './dialogHelp.vue';
import dialogHelFishpVue from './dialogHelpFish.vue';
import dialogHelpChineseStyleVue from './dialogHelpChineseStyle.vue';
import dialogHelpSwiperVue from './dialogHelpSwiper.vue';
import dialogHelp2dFish from './dialogHelp2dFish.vue';

const DialogHelp = (options) => {
	/**首先判断是否是2D捕鱼 */
	const fish2d = [1018, 1048, 1049, 1050, 1051,1054];
	/**然后判断是否是中国风的游戏 */
	const chineseStyleGameId = [1027, 1013, 1301, 1302, 1303];
	/**再特殊处理捕鱼的帮助 */
	const fishGameId = [1001, 1046, 1047, 1146];
	/**处理老虎机的帮助,老虎机用swiper */
	const swiperGameId = [1401, 1402, 1403, 1404, 1405];
	/*style为2则直接走中中国风的帮助 */
	const DialogHelpConstructor = Vue.extend(
		options.style == 2
			? dialogHelpChineseStyleVue
			: fish2d.includes(options.gameId)
				? dialogHelp2dFish
				: chineseStyleGameId.includes(options.gameId)
					? dialogHelpChineseStyleVue
					: fishGameId.includes(options.gameId)
						? dialogHelFishpVue
						: swiperGameId.includes(options.gameId) ? dialogHelpSwiperVue : dialogHelpVue
	);
	let instance = new DialogHelpConstructor({
		data: options
	});
	instance._vm = instance.$mount();
	instance._el = instance.$el;
	instance._instance = instance;
	document.body.appendChild(instance.$el); // 把生成的提示的dom插入body中
	return instance;
};

export default DialogHelp;
